import { useCallback } from 'react'
import { useNavigate } from 'react-router'
import { useAsync } from 'react-use'
import {
  isAppVersionGreaterThanOrEqualTo,
  navigateToNativePage,
} from 'src/utils/jsBridge/implementation'
import { NativeNavigation } from 'src/utils/jsBridge/nativeNavigation'
import { track } from 'src/utils/tracker'
import { isAppWebview } from 'src/utils/userAgent'
import { UIButton } from '../ui/Button'
import { UIDialog } from '../ui/Modal'
import Text from '../ui/Text'

export function openVerifyEmailModal() {
  return UIDialog.create({
    dismissable: true,
    heading: (
      <Text i18nKey={'user:profile.email.verification-required-dialog.title'} />
    ),
    content: (
      <Text
        i18nKey={'user:profile.email.verification-required-dialog.content'}
      />
    ),
    footer: ({ close }) => <VerifyEmailModalContentFooter onClose={close} />,
    type: 'dialog',
  })
}

function useNativeSupportEditAccount() {
  const isWebview = isAppWebview()
  const { value: supportEditAccount } = useAsync(() => {
    if (!isWebview) return Promise.resolve(false)
    return isAppVersionGreaterThanOrEqualTo('3.25.0')
  }, [isWebview])
  return supportEditAccount
}

function VerifyEmailModalContentFooter(props: { onClose: () => void }) {
  const supportNativeEditAccount = useNativeSupportEditAccount()
  const navigate = useNavigate()
  const onCancel = () => {
    track('email_verify_cancel_click')
    props.onClose()
  }
  const onConfirm = useCallback(() => {
    track('email_verify_yes_click')
    if (supportNativeEditAccount) {
      navigateToNativePage({
        route: NativeNavigation.editProfile(),
      })
    } else {
      navigate(`/profile/edit/accounts`)
    }
    props.onClose()
  }, [supportNativeEditAccount])

  return (
    <>
      <UIButton
        onPress={onCancel}
        className="max-msm:flex-1 min-w-16 capitalize"
      >
        <Text i18nKey="action:cancel" />
      </UIButton>
      <UIButton
        onPress={onConfirm}
        variant="filled"
        className="max-msm:flex-1 min-w-16 capitalize"
      >
        <Text i18nKey="action:confirm" />
      </UIButton>
    </>
  )
}
